import { useCallback, useRef, useState } from 'react'
import { v4 as uuidv4 } from "uuid";
import { AUTH_KEY, ETERNAL_REFRESH_TOKEN } from '../../consts/auth';

const useRetryImage = ({ isVideo = false } = {}) => {
    // media is processed by the backend in approximately 30 seconds for image, 10 minutes for video or less.
    // if it exceeds 10 retries, show failed message.
    // images will retry to load every 30 seconds.
    // videos will retry to load every 10 minutes.
    const maxRetry = 10
    const retryDelay = 30 * 1000 * (isVideo ? 20: 1) // miliseconds
    const [retryKey, setRetryKey] = useState(uuidv4())
    const [retryFailed, setRetryFailed] = useState(false)
    const retry = useRef(null)
    const retryCount = useRef(null)

    const retryOnError = useCallback(() => {
        try {
            if ((retryCount.current || 0) < maxRetry) {
                retry.current = setTimeout(() => {
                    retryCount.current = retryCount.current + 1
                    setRetryKey(uuidv4())
                }, retryDelay)
            } else {
                console.debug('[666] retry image failed after max retries')
                console.debug('[666] current refresh token', localStorage.getItem(ETERNAL_REFRESH_TOKEN))
                console.debug('[666] current auth state', JSON.parse(localStorage.getItem(`${AUTH_KEY}_state`)))
                setRetryFailed(true)
            }
        } catch (e) {
            console.error('retry image failed', e)
        }
    }, [retryCount, retryDelay, maxRetry])

    const resetRetryOnLoad = useCallback(() => {
        try {
            retry.current = null
            retryCount.current = 0
        } catch {}
    }, [])

    return {
        retryOnError,
        resetRetryOnLoad,
        retryKey,
        retryFailed,
    }
}

export default useRetryImage